export default {
    data() {
        return {
            alert: {
                show: false,
                type: 'success',
                title: '',
                text: '',
                allowOutsideClick: true,
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: 'OK',
                confirmButtonClass: '',
                cancelButtonText: 'Cancel',
                cancelButtonClass: '',
                buttonsStyling: true,
                reverseButtons: false,
                onConfirm: () => {},
                onCancel: () => {},
            }
        }
    },
    computed: {
        defaultConfig() {
            return {
                title: '',
                text: '',
                type: 'success',
                allowOutsideClick: true,
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: 'OK',
                confirmButtonClass: '',
                cancelButtonText: 'Cancel',
                cancelButtonClass: '',
                buttonsStyling: true,
                reverseButtons: false,
            }
        }
    },
    methods: {
        handleAlertClose() {
            this.alert.show = false;
        },
        fireSuccessAlert(config) {
            this.setupAlertConfig({
                type: 'success',
                ...config
            });
        },
        fireWarningAlert(config) {
            this.setupAlertConfig({
                type: 'warning',
                ...config
            });
        },
        fireErrorAlert(config) {
            this.setupAlertConfig({
                type: 'error',
                ...config
            });
        },
        setupAlertConfig(config) {
            Object.keys(this.defaultConfig).forEach((key) => {
                this.alert[key] = config.hasOwnProperty(key)
                    ? config[key]
                    : this.defaultConfig[key];
            });

            this.alert.onConfirm = config.hasOwnProperty('onConfirm')
                ? config.onConfirm
                : this.handleAlertClose;

            this.alert.onCancel = config.hasOwnProperty('onCancel')
                ? config.onCancel
                : this.handleAlertClose;

            this.alert.show = true;
        }
    }
}
